// extracted by css-extract-rspack-plugin
export default {"content":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-components-AlertDetails-AlertDetails-module__content-V0NXS7","message":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-components-AlertDetails-AlertDetails-module__message-b84umb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"content\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-components-AlertDetails-AlertDetails-module__content-V0NXS7\",\"message\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-components-AlertDetails-AlertDetails-module__message-b84umb\"}";
        // 1791855167442
        var cssReload = require("../../../../../../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  